import { jsx as e } from "react/jsx-runtime";
import t from "react";
const f = t.memo(({
  color: l = "#025CC2",
  width: o = 16,
  height: a = 16
}) => /* @__PURE__ */ e("svg", { fill: "none", height: a, viewBox: "0 0 16 16", width: o, children: /* @__PURE__ */ e("path", { clipRule: "evenodd", d: "M8.125 4.5a4 4 0 1 0 3.668 5.6 1 1 0 1 1 1.832.8 6 6 0 1 1-2.11-7.351l.58-.58a.75.75 0 0 1 1.27.408l.5 3a.75.75 0 0 1-.863.863l-3-.5a.75.75 0 0 1-.407-1.27l.47-.47a3.98 3.98 0 0 0-1.94-.5z", fill: l, fillRule: "evenodd" }) }));
export {
  f as default
};
//# sourceMappingURL=ResetIcon.es.js.map
